import type { IncidentAnnouncement } from "./diplomacy-types.js";

export function publicPair(
  kind: "pact-accepted" | "pact-notice-issued" | "pact-ended",
  actorId: string,
  targetId: string,
) {
  return { kind, actorId, targetId };
}

export function publicIncident(
  kind: "incident-warning" | "incident-resolved" | "incident-cancelled",
  incident: IncidentAnnouncement,
) {
  return { kind, incident };
}
